import { CommonModule } from '@angular/common';
import { Component, computed, ElementRef, inject, OnInit, signal, ViewChild } from '@angular/core';
import { MenubarModule } from 'primeng/menubar';
import { MatMenuModule } from '@angular/material/menu';
import { BadgeModule } from 'primeng/badge';
import { AvatarModule } from 'primeng/avatar';
import { InputTextModule } from 'primeng/inputtext';
import { ActivatedRoute, Router, RouterLink } from '@angular/router';
import { BreakpointObserver } from '@angular/cdk/layout';
import { DropdownModule } from 'primeng/dropdown';
import { environment } from '@env/environment';
import { VerifyPopupComponent } from '../verify-popup/verify-popup.component';
import { BsModalRef, BsModalService } from 'ngx-bootstrap/modal';
import { AccordionModule } from 'primeng/accordion';
import { AuthService } from '../../../features/auth/services/auth.service';
import { ProfileService } from 'app/features/user/profile/services/profile.service';
import { UserProfilePictureComponent } from '../user-profile-picture/user-profile-picture.component';
import { NavbarNotificationsComponent } from '../navbar-notifications/navbar-notifications.component';
import { SearchComponent } from 'app/search/search.component';
import { NavbarMessagesComponent } from '../navbar-messages-component/navbar-messages.component';
import { SocketService } from 'app/features/user/services/socket.service';
@Component({
  selector: 'app-navbar',
  standalone: true,
  imports: [
    CommonModule,
    RouterLink,
    MenubarModule,
    BadgeModule,
    AvatarModule,
    InputTextModule,
    DropdownModule,
    MatMenuModule,
    AccordionModule,
    UserProfilePictureComponent,
    NavbarNotificationsComponent,
    SearchComponent,
    NavbarMessagesComponent,
  ],
  templateUrl: './navbar.component.html',
  styleUrl: './navbar.component.scss',
})
export class NavbarComponent implements OnInit {
  items: any[] | undefined;
  type: any = '';
  exist_user: any = null;
  isMenuOpen = false;
  isDropdownOpen = false;
  isMobileUserDropdownOpen = false;
  isMobile: boolean = false;
  freelancer_settings_menu: any[] = [];
  user_settings_menu: any[] = [];
  clientNavItems: { path: string; label: string }[] = [
    { path: '/client/project/create', label: 'Create project' },
    { path: '/client/projects', label: 'My projects' },
    { path: '/client/requests', label: 'Requests' },
  ];
  freelancerNavItems: { path: string; label: string }[] = [
    { path: '/create/service', label: 'Create Service' },
    { path: '/freelancer/proposals', label: 'My proposals' },
    { path: '/orders', label: 'Requests' },
  ];
  user: any;
  environment = environment.files;
  modalRef?: BsModalRef;
  username: any = '';
  isOwner: any;
  mode: any;
  private viewed = signal(false);
  user_signal = computed(() => this.auth.currentUserSignal()?.user);
  hasUnviewed = computed(() => {
    if (this.viewed()) return false;
    const u = this.user_signal() as Record<string, unknown> | undefined;
    return !!(u?.['has_unviewed_notifications'] as boolean);
  });
  constructor(
    private route: ActivatedRoute,
    private modalService: BsModalService,
    private router: Router,
    private breakpointObserver: BreakpointObserver,
    private auth: AuthService,
    private service: ProfileService
  ) {
    this.username = this.route.snapshot.paramMap.get('username')!;
    if (this.auth.currentUserValue?.user) {
      this.auth.currentUser.subscribe((data: any) => {
        this.user = data?.user;
        this.type = this.user?.type;
        console.log('initialize socket');
      });
      this.exist_user = !!this.user;
      // this.exist_user = Object.keys(this.auth.currentUserValue?.user).length != 0 ? true : false;
    }
    this.breakpointObserver.observe(['(max-width:800px)']).subscribe((result) => {
      if (!result.matches) {
        this.closeMenu();
      }
    });

    this.freelancer_settings_menu = [
      {
        id: 1,
        path: `/profile/${this.user?.username}`,

        title: 'Profile',
      },
      {
        id: 2,
        path: 'settings/personal-information/',
        title: 'Account Settings',
      },
      { id: 3, path: 'freelancer/proposals', title: 'My Proposal' },
      { id: 4, path: '/orders', title: 'Requests' },
      { id: 5, path: '/wallet', title: 'Wallet' },
    ];
    this.user_settings_menu = [
      {
        id: 1,
        path: `/profile/${this.user?.username}`,
        title: 'Profile',
      },
      {
        id: 2,
        path: 'settings/personal-information',
        title: 'Account Settings',
      },
      { id: 3, path: '/client/projects', title: 'My Projects' },
      { id: 4, path: '/wallet', title: 'Wallet' },
    ];
  }
  ngOnInit(): void {
    this.items = [
      'About Us',
      'Posts',
      'Categories',
      'Services',
      'Projects',
      'Guides',
      'Contact Us',
    ];
  }

  onSettingClick(setting: any) {
    const fullUrl = this.router.url;
    if (fullUrl.split('/')[2] == this.user?.username) return;
    if (setting.title === 'Profile') {
      this.goProfile(this.user?.username);
    }
  }
  refresHome() {
    if (this.type == 'client') {
      this.router.navigate(['/client/services']);
    } else if (this.type == 'freelancer') {
      this.router.navigate(['/freelancer/projects']);
    } else {
      this.router.navigate(['/home']);
    }
  }

  goProfile(username: any) {
    const currentUrl = this.router.url;
    const newUrl = `/profile/${username}`;

    if (username === this.username) {
      this.router.navigateByUrl(currentUrl);
      return;
    }
    this.service.previewMode.set(false);
    this.router.navigateByUrl(newUrl);
  }

  logout() {
    this.auth.logout().subscribe();
  }

  toggleMenu() {
    this.isMenuOpen = !this.isMenuOpen;
  }

  closeMenu() {
    this.isMenuOpen = false;
  }

  toggleDropdown() {
    this.isDropdownOpen = !this.isDropdownOpen;
  }

  toggleMobileUserDropdown() {
    this.isMobileUserDropdownOpen = !this.isMobileUserDropdownOpen;
  }

  openVerifyModal() {
    const initialState = {
      type: this.user?.user?.type,
    };
    this.modalRef = this.modalService.show(VerifyPopupComponent, {
      initialState,
      backdrop: 'static', // يمنع الإغلاق عند الضغط برّه
      keyboard: false, // يمنع الإغلاق بزر Esc
    });
    this.modalRef.onHidden?.subscribe(() => {});
  }
}
